export interface PopupItem {
  title: string;
  description: string;
  icon: string;
}

export class AchievementPopup {
  private static queue: PopupItem[] = [];
  private static isShowing = false;

  static show(title: string, description: string, icon: string): void {
    this.queue.push({ title, description, icon });
    if (!this.isShowing) {
      this.processQueue();
    }
  }

  private static processQueue(): void {
    if (this.queue.length === 0) {
      this.isShowing = false;
      return;
    }

    this.isShowing = true;
    const item = this.queue.shift()!;
    this.renderPopup(item);
  }

  private static renderPopup(item: PopupItem): void {
    const container = document.createElement('div');
    
    // Rastgele konfeti renkleri
    const colors = ['#ef4444', '#f59e0b', '#10b981', '#3b82f6', '#8b5cf6', '#ec4899'];
    let confettiHTML = '';
    for (let i = 0; i < 40; i++) {
      const left = Math.random() * 100;
      const animDelay = Math.random() * 0.5;
      const animDuration = 1 + Math.random() * 1.5;
      const color = colors[Math.floor(Math.random() * colors.length)];
      confettiHTML += `<div style="
        position: absolute;
        width: 6px;
        height: 12px;
        background-color: ${color};
        top: -20px;
        left: ${left}%;
        opacity: 0;
        animation: confetti-fall ${animDuration}s ease-in ${animDelay}s forwards;
        border-radius: ${Math.random() > 0.5 ? '2px' : '50%'};
      "></div>`;
    }

    container.innerHTML = `
      <style>
        @keyframes slide-in-top {
          0% { transform: translate(-50%, -100%); opacity: 0; }
          10% { transform: translate(-50%, 20px); opacity: 1; }
          90% { transform: translate(-50%, 20px); opacity: 1; }
          100% { transform: translate(-50%, -100%); opacity: 0; }
        }
        @keyframes confetti-fall {
          0% { transform: translateY(0) rotate(0deg); opacity: 1; }
          100% { transform: translateY(100vh) rotate(720deg); opacity: 0; }
        }
        .confetti-container {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          pointer-events: none;
          z-index: 9999;
          overflow: hidden;
        }
        .achievement-popup {
          position: fixed;
          top: 0;
          left: 50%;
          transform: translate(-50%, -100%);
          background: linear-gradient(135deg, rgba(30, 41, 59, 0.95), rgba(15, 23, 42, 0.95));
          border: 2px solid #fbbf24;
          box-shadow: 0 10px 30px rgba(251, 191, 36, 0.3), inset 0 0 15px rgba(251, 191, 36, 0.1);
          border-radius: 16px;
          padding: 16px 24px;
          display: flex;
          align-items: center;
          gap: 16px;
          z-index: 10000;
          color: white;
          min-width: 300px;
          animation: slide-in-top 6s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
          pointer-events: none;
          backdrop-filter: blur(8px);
          overflow: hidden;
        }
        .achievement-icon {
          font-size: 2.5rem;
          filter: drop-shadow(0 0 8px rgba(251, 191, 36, 0.8));
          animation: pulse 2s infinite;
        }
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }
      </style>
      <div class="confetti-container">
        ${confettiHTML}
      </div>
      <div class="achievement-popup">
        <div class="achievement-icon">${item.icon}</div>
        <div style="z-index: 2;">
          <div style="color: #fbbf24; font-size: 0.75rem; font-weight: 800; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 2px;">Başarım Kazanıldı</div>
          <div style="font-size: 1.1rem; font-weight: bold; margin-bottom: 4px; text-shadow: 0 2px 4px rgba(0,0,0,0.5);">${item.title}</div>
          <div style="font-size: 0.85rem; color: #cbd5e1; line-height: 1.3;">${item.description}</div>
        </div>
      </div>
    `;

    document.body.appendChild(container);

    setTimeout(() => {
      if (document.body.contains(container)) {
        document.body.removeChild(container);
      }
      // Process next item in queue after current one finishes
      this.processQueue();
    }, 6500); // Wait for the 6s animation to finish + a tiny buffer
  }
}
